import type { RouteRecordRaw } from 'vue-router';
import { signinRoutes } from './routes/index';
import { dashboardRoutes } from './routes/dashboard';
import { planRoutes } from './routes/plan';
import { storeRoutes } from './routes/store';
import { userRoutes } from './routes/user';
import { serviceRoutes } from './routes/service';
import { featureRoutes } from './routes/feature';
import { paymentRoutes } from './routes/payment';
import { defaultstaffRoutes } from './routes/defaultstaff';
import { defaultstoreRoutes } from './routes/defaultstore';
import { transactionRoutes } from './routes/transaction';
import { globalconfigRoutes } from './routes/globalconfig';
import { featureFlagRoutes } from './routes/featureflags';

const routes: RouteRecordRaw[] = [
  featureFlagRoutes,
  globalconfigRoutes,
  transactionRoutes,
  defaultstoreRoutes,
  defaultstaffRoutes,
  paymentRoutes,
  featureRoutes,
  serviceRoutes,
  userRoutes,
  storeRoutes,
  planRoutes,
  dashboardRoutes,
  signinRoutes,
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('@/pages/Forbidden.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/Error404.vue')
  }
];

export default routes;
